<template>
  <div>
    <input
      type="checkbox"
      id="daynight"
      class="dayNight"
      v-model="daynight"
      v-on:change="daynightUpdate"
    />
  </div>
</template>
<script>
/* import iconDay from "@/assets/images/icons/day.svg";
import iconNight from "@/assets/images/icons/night.svg";
 */
export default {
  props: {
    checked: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      daynight: false
    };
  },
  methods: {
    daynightUpdate: function() {
      if (this.daynight)
        document.getElementById("filter_layer").classList.add("invert");
      else document.getElementById("filter_layer").classList.remove("invert");
    }
  }
};
</script>

<style scoped lang="scss">
@import "@/assets/sass/colors";
.dayNight {
  border: none !important;
  background: transparent !important;
  width: 48px;
  height: 32px;
  cursor: pointer;
  position: relative;
  margin-top: 4px;
  border-radius: 100%;
  appearance: inherit;
  outline-width: 0;
  /* clip: rect(0 0 0 0);
  height: 1px;
  margin: -1px;
  overflow: hidden;
  padding: 0;
  position: absolute;
  width: 1px; */
}
.dayNight:focus {
  outline: none;
}
.dayNight:before {
  position: absolute;
  width: 48px;
  height: 32px;
  content: "";
  background: $soutien;
  border-radius: 16px;
  pointer-events: none;
}
.dayNight:after {
  position: absolute;
  width: 32px;
  height: 32px;
  content: "";
  background: $primary;
  border-radius: 16px;
  left: 0px;
  pointer-events: none;
  transition: left 0.1s linear;
  background-image: url("../../assets/images/SVG/night.svg");
}

.dayNight:checked:after {
  position: absolute;
  width: 32px;
  height: 32px;
  left: 15px;
  content: "";
  background: $primary;
  border-radius: 16px;
  pointer-events: none;
  background-image: url("../../assets/images/SVG/day.svg");
}
</style>